interface UseDisplayedNotificationsReturn {
  isRead: (id: string) => boolean;
  markAsRead: (key: string) => void;
  /** Per-notification read state, independent of the global `hasUnreadNotificationsCenter` key. */
  isNotificationRead: (id: string) => boolean;
  markNotificationAsRead: (id: string) => void;
}

const readDisplayedNotifications = (): Record<string, boolean> => {
  try {
    return JSON.parse(sessionStorage.getItem('displayedNotifications') ?? '{}');
  } catch {
    return {};
  }
};

const READ_NOTIFICATION_IDS_KEY = 'readNotificationIds';

const readReadNotificationIds = (): string[] => {
  try {
    return JSON.parse(sessionStorage.getItem(READ_NOTIFICATION_IDS_KEY) ?? '[]');
  } catch {
    return [];
  }
};

export const useDisplayedNotifications = (): UseDisplayedNotificationsReturn => {
  const isRead = (key: string): boolean => {
    const displayedNotifications = readDisplayedNotifications();
    return !!displayedNotifications[key];
  };

  const markAsRead = (overrideKey: string) => {
    const displayedNotifications = readDisplayedNotifications();
    displayedNotifications[overrideKey] = true;
    sessionStorage.setItem('displayedNotifications', JSON.stringify(displayedNotifications));
  };

  const isNotificationRead = (id: string): boolean => readReadNotificationIds().includes(id);

  const markNotificationAsRead = (id: string) => {
    const readIds = readReadNotificationIds();
    if (!readIds.includes(id)) {
      sessionStorage.setItem(READ_NOTIFICATION_IDS_KEY, JSON.stringify([...readIds, id]));
    }
  };

  return { isRead, markAsRead, isNotificationRead, markNotificationAsRead };
};
